import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../../context/ConstantAPISContext";
import { showToast } from "../../../../helpers/ToastifyHelper";
import { Form, Formik } from "formik";
import { FormControl, InputLabel, MenuItem, Select, CircularProgress } from "@mui/material";
import SearchComponent from "../../../../components/OB/SearchComponent";
import TableComponent from "../../../../components/OB/TableComponent";
import InsaatTuruAPI from "../../../../apis/OB/Get/InsaatTuruAPI";
import BinaAsinmaOranlariAPI from "../../../../apis/OB/Get/BinaAsinmaOranlariAPI";

const BinaAsinmaOranlari: React.FC = () => {
  const columns = [
    { header: "İnşaat Türü", field: "insaatTuruAdi", className: "text-center" },
    { header: "Aşınma Yaşı", field: "asinmaYasi", className: "text-center" },
    { header: "Aşınma Oranı", field: "asinmaOrani", className: "text-center" },
  ];
  const [data, setData] = useState<any[]>([]);
  const [insaatTuruData, setInsaatTuruData] = useState<any[]>([]);
  const [isLoading, setisLoading] = useState<boolean>(false);
  const [searchControl, setSearchControl] = useState<boolean>(true);
  const { yilListe } = useContext(ConstantAPISContext);
  const [selectedYear, setSelectedYear] = useState(
    Number(new Date().getFullYear())
  );
  const [selectedInsaatTuru, setSelectedInsaatTuru] = useState<any>();

  //İnşaat Türü API
  useEffect(() => {
    InsaatTuruAPI.getInsaatTuruListe(undefined)
      .then((res) => {
        setInsaatTuruData(res.data);
      })
      .catch((err) => { });
  }, []);

  //InsaatMaaliyetBedelleriAPI
  useEffect(() => {
    fetchData(false);
  }, []);


  const fetchData = async (isPass: boolean = true) => {
    if (selectedYear !== 0) {
      setisLoading(true);
      const response = await BinaAsinmaOranlariAPI.getBinaAsinmaOranlariListe(
        selectedYear,
        selectedInsaatTuru
      );
      setData(response.data);
      setTimeout(() => {
        setisLoading(false);

      }, 100)
      setSearchControl(true);
    } else {
      setSearchControl(false);
      showToast("Lütfen Yılı Seçiniz", "error");
    }
  };

  const handleTemizle = () => {
    setSelectedYear(Number(new Date().getFullYear()));
    setSelectedInsaatTuru(undefined);
  };

  //Formik constantları
  const initialValues = {
    //boş kalacak ihtiyaca göre kullanılabilir
  };
  return (
    <div className="px-1 px-md-2 px-lg-4 py-3 card   w-100">
      <div className="card-body p-0">
        <Formik initialValues={initialValues} onSubmit={() => { }}>
          <Form id="kayit-form" className="d-flex w-100 mb-4">
            <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
              <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                <FormControl size="small"
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "50%",
                      md: "25%",
                    },
                    minWidth: 140
                  }}>

                  <InputLabel id="">Yıl</InputLabel>
                  <Select
                    sx={{
                      backgroundColor: "white",
                    }}
                    labelId=""
                    id=""
                    name="yil"
                    label="yil"
                    error={
                      selectedYear == undefined && searchControl == false
                        ? true
                        : false
                    }
                    value={selectedYear || ""}
                    onChange={(e) => {
                      setSelectedYear(Number(e.target.value || undefined));
                    }}
                  >
                    {yilListe.map((item) => (
                      <MenuItem key={item} value={item.yili}>
                        {item.yili}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small"
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "50%",
                      md: "25%",
                    },
                    minWidth: 140
                  }}>

                  <InputLabel id="">Kullanım Şekli</InputLabel>
                  <Select
                    sx={{
                      backgroundColor: "white",
                    }}
                    labelId=""
                    id=""
                    value={selectedInsaatTuru || ""}
                    label="Kullanım Şekli"
                    onChange={(e) => {
                      setSelectedInsaatTuru(
                        Number(e.target.value || undefined)
                      );
                    }}
                  >
                    {insaatTuruData.map((item) => (
                      <MenuItem key={item} value={item.insaatTuruKodu}>
                        {item.insaatTuruAdi}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="d-flex  flex-row ms-auto ">
                <SearchComponent
                  fetchData={fetchData}
                  onTemizle={handleTemizle}
                  setData={setData}
                />
              </div>
            </div>
          </Form>
        </Formik>
        {isLoading ?
          <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

            <CircularProgress />
          </div>
          :
          <TableComponent
            columns={columns}
            data={data}
            recordsPerPage={12}
          ></TableComponent>
        }
      </div>
    </div>
  );
};

export default BinaAsinmaOranlari;
